import React from 'react';
import styles from './step-summary.module.scss';
import { formatPhoneNumber } from 'shared/ui';

interface ISummaryData {
  serviceDuration?: string;
  serviceEndTime?: string;
  time?: string;
  service?: string;
  employee?: string;
  date?: string;
  name?: string;
  phone?: string;
  comment?: string;
  price?: string;
}

interface IStepSummary {
  data: ISummaryData;
}

export const StepSummary: React.FC<IStepSummary> = ({ data }) => {
  const rows = [
    { label: 'Услуга', value: data.service },
    { label: 'Специалист', value: data.employee },
    { label: 'Дата', value: data.date },
    { label: 'Время', value: `${data.time} - ${data.serviceEndTime}` },
    { label: 'Длительность', value: `${data.serviceDuration} мин.` },
    { label: 'Цена', value: data.price ? `${data.price} ₽` : '—' },
    { label: 'Клиент', value: data.name },
    {
      label: 'Телефон ',
      value: formatPhoneNumber(data.phone ?? '') || data.phone,
    },
  ];

  return (
    <div className={styles.summary__container}>
      {rows.map((row) => (
        <div key={row.label} className={styles.summary__row}>
          <span className={styles.summary__label}>{row.label}</span>
          <span className={styles.summary__value}>{row.value || '—'}</span>
        </div>
      ))}
      {data.comment && (
        <div className={styles.summary__row}>
          <span className={styles.summary__label}>Комментарий</span>
          <span className={styles.summary__value}>{data.comment}</span>
        </div>
      )}
    </div>
  );
};
